<template>
    <form @submit.prevent="submitForm">
<div class="row">
    <div class="col-md-8">
                <field-markdown required v-model="form.about_fa" label="دربراه ما" placeholder=""/>
        <field-markdown required v-model="form.about_en" label="about us" placeholder=""/>
    </div>
    <div class="col-md-4">

           <field-image required v-model="form.image_src"
                             link="fa/v1/setting/upload-image"
                             placeholder=""/>
    </div>

</div>



        <alert :success="success" :danger="danger"></alert>
        <button-submit title="ثبت"/>
    </form>
</template>


<script>
import ButtonSubmit from "../../ButtonSubmit";
import Alert from "../../Alert";

import mixinForm from "../../../mixins/mixinForm";
import FieldTextarea from "../../fields/FieldTextarea";
import FieldMarkdown from "../../fields/FieldMarkdown";
import FieldImage from "../../fields/FieldImage";

export default {
  mixins: [mixinForm],
  components: {
    FieldMarkdown,
    FieldTextarea,
    Alert,
    ButtonSubmit,
    FieldImage
  },
  name: "FormAbout",
  data() {
    return {
      action: "/settings"
    };
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/forms/setting/FormAbout.vue